import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WithdrawalHistoryPage } from './withdrawal-history.page';

const routes: Routes = [
  {
    path: '',
    component: WithdrawalHistoryPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WithdrawalHistoryPageRoutingModule {}
